import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/74ab1a93/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Button } from '../components/Button';
import { useAuth, login } from "react-use-auth";
import { navigate } from 'gatsby';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "add-authentication-to-your-react-app"
    }}>{`Add authentication to your React app`}</h1>
    <p>{`useAuth is an open source and free way to add `}<strong parentName="p">{`authentication`}</strong>{` to your React `}<strong parentName="p">{`app`}</strong></p>
    <div style={{
      padding: '33px'
    }}>
  <Button onClick={() => navigate('/setup')} scale="big" kind="cancel" mdxType="Button">Get Started </Button>
    </div>
    <h1 {...{
      "id": "how-useauth-works"
    }}>{`How useAuth works`}</h1>
    <p>{`The simplest way for React developers to add authentication, useAuth handles everything for you. Users, login forms, redirects, sharing state between components. Everything`}</p>
    <h1 {...{
      "id": "say-hi-to-your-user-when-she-logs-in"
    }}>{`Say hi to your user when she logs in`}</h1>
    <p><img alt="Say hi to your user gif" src="https://camo.githubusercontent.com/e5f8a596e3406a7129d347b2cc6bbe4a3e76da02/68747470733a2f2f692e696d6775722e636f6d2f4b756e45656d4e2e676966" /></p>
    <h1 {...{
      "id": "curious-yet"
    }}>{`Curious yet?`}</h1>
    <p>{`It only takes a few minutes to get up and running!`}</p>
    <div style={{
      padding: '33px'
    }}>
  <Button onClick={() => navigate('/setup')} scale="big" kind="primary" mdxType="Button">Get Started </Button>
    </div>
    <h1 {...{
      "id": "these-secure-sites-use-useauth"
    }}>{`These secure sites use useAuth`}</h1>
    <ul>
      <li parentName="ul"><a href="https://useauth.dev/" alt="">https://useauth.dev/</a></li>
      <li parentName="ul"><a href="https://kidbook.netlify.com/" alt="">Lillian's Children's Book Site</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      